import { render, staticRenderFns } from "./ConversacionesIaPanel.vue?vue&type=template&id=008e4ebb&scoped=true&lang=pug"
import script from "./ConversacionesIaPanel.vue?vue&type=script&lang=js"
export * from "./ConversacionesIaPanel.vue?vue&type=script&lang=js"
import style0 from "./ConversacionesIaPanel.vue?vue&type=style&index=0&id=008e4ebb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008e4ebb",
  null
  
)

export default component.exports